import { Injectable } from '@angular/core';
import { RequestService } from '@core/services/request/request.service';
import { CarbonTrackApi } from '../../model/sustainability/carbon-track-api.model';
import { ApiDirectory } from '../../api-directory';
import { RequestResponse } from '@core/services/request/model/request.model';
import { LoadingIds } from '@shared/constants/loading';
import { Observable } from 'rxjs';
import { CarbonTrackFilters } from '@pages/sustainability/ui/carbon-track/models/carbon-track-filters.model';
import { CarbonTrackFiltersMapper } from '@core/domain/mappers/sustainability/carbon-track-filters.mapper';
import { OriginWarrantyApi, OriginWarrantyApiRequest } from '../../model/sustainability/origin-warranty-api.model';
import { CarbonTrackPdfRequest } from '@pages/sustainability/ui/carbon-track/models/carbon-track-pdf-request.model';
import { HttpEvent } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class ApiSustainabilityService {
  constructor(private _requestService: RequestService) {}

  public fetchCarbonTrack(filters: CarbonTrackFilters, specialLoading?: LoadingIds): Observable<RequestResponse<CarbonTrackApi>> {
    return this._requestService.get(ApiDirectory.Sostenibilidad.DatosHuellaCarbono({}), {
      params: CarbonTrackFiltersMapper.buildParams(filters),
      loading: specialLoading ?? LoadingIds.FETCH_SUSTAINABILITY_CARBON_TRACK,
      hideErrorAlert: true,
    });
  }

  public downloadCarbonTrackPdf(request: CarbonTrackPdfRequest): Observable<HttpEvent<Blob>> {
    return this._requestService.downloadWithProgressPost<CarbonTrackPdfRequest>(
      ApiDirectory.Sostenibilidad.DatosHuellaCarbonoPdf({}),
      request
    );
  }

  public fetchOriginWarranty(body: OriginWarrantyApiRequest): Observable<RequestResponse<OriginWarrantyApi>> {
    return this._requestService.post(ApiDirectory.Sostenibilidad.GarantiaOrigen({}), body, {
      loading: LoadingIds.FETCH_SUSTAINABILITY_ORIGIN_WARRANTY,
      hideErrorAlert: true,
    });
  }

  public downloadOriginWarrantyPdf(body: OriginWarrantyApiRequest) {
    return this._requestService.downloadWithProgressPost<OriginWarrantyApiRequest>(ApiDirectory.Sostenibilidad.GarantiaOrigenPdf({}), body);
  }

  public downloadCertificate(code: string) {
    return this._requestService.downloadWithProgress(ApiDirectory.Sostenibilidad.Certificado({ codCertificado: code }));
  }
}
